export function formatMoney(amount, currency = "usd") {
  const value = Number(amount ?? 0);

  return new Intl.NumberFormat("en-CA", {
    style: "currency",

    currency: (currency || "usd").toUpperCase(),
  }).format(value);
}

/* =========================================================
   CURRENT VARIANT PRICE
   ========================================================= */

export function getVariantPrice(variant) {
  return (
    variant?.calculated_price?.calculated_amount ??
    variant?.calculated_price?.original_amount ??
    null
  );
}

/* =========================================================
   CURRENT PRICE + SALE DATA
   ========================================================= */

export function getVariantPriceData(variant) {
  const calculated = variant?.calculated_price;

  if (!calculated) {
    return {
      current: null,

      original: null,

      currency: "cad",

      isOnSale: false,

      savingsAmount: 0,

      savingsPercent: 0,
    };
  }

  const current =
    calculated.calculated_amount !== null &&
    calculated.calculated_amount !== undefined
      ? Number(calculated.calculated_amount)
      : null;

  const original =
    calculated.original_amount !== null &&
    calculated.original_amount !== undefined
      ? Number(calculated.original_amount)
      : current;

  const currency = calculated.currency_code || "cad";

  const isOnSale = current !== null && original !== null && original > current;

  const savingsAmount = isOnSale ? Number((original - current).toFixed(2)) : 0;

  const savingsPercent =
    isOnSale && original > 0 ? Math.round((savingsAmount / original) * 100) : 0;

  return {
    current,

    original,

    currency,

    isOnSale,

    savingsAmount,

    savingsPercent,
  };
}

/* =========================================================
   SALE BADGE
   ========================================================= */

export function getSaleBadgeLabel(priceData) {
  if (!priceData?.isOnSale) {
    return "";
  }

  if (priceData.savingsPercent > 0) {
    return `Save ${priceData.savingsPercent}%`;
  }

  return `Save ${formatMoney(
    priceData.savingsAmount,

    priceData.currency,
  )}`;
}

/* =========================================================
   INVENTORY
   ========================================================= */

export function isVariantInStock(variant) {
  if (!variant) {
    return false;
  }

  if (variant.allow_backorder) {
    return true;
  }

  if (variant.manage_inventory === false) {
    return true;
  }

  if (
    variant.inventory_quantity !== null &&
    variant.inventory_quantity !== undefined
  ) {
    return Number(variant.inventory_quantity) > 0;
  }

  return true;
}
